import { BASE_URL, AUTH_HEADERS } from "./config";

export const getEvents = async ({ leadId = null, eventType = null, objectType = null, objectId = null, userId = null, page = null, page_size = null } = {}) => {
	const url = new URL(`${BASE_URL}/events`);
	if (leadId) url.searchParams.append("lead_id", leadId);
	if (eventType) url.searchParams.append("event_type", eventType);
	if (objectType) url.searchParams.append("object_type", objectType);
	if (objectId) url.searchParams.append("object_id", objectId);
	if (userId) url.searchParams.append("user_id", userId);
	if (page) url.searchParams.append("page", page);
	if (page_size) url.searchParams.append("page_size", page_size);

	try {
		const response = await fetch(url.toString(), { headers: AUTH_HEADERS });
		if (response.ok) {
			return await response.json();
		}
	} catch (e) {
		// ignore
	}
	return [];
};

export const getEvent = async (id) => {
	try {
		const response = await fetch(`${BASE_URL}/events/${id}`, { headers: AUTH_HEADERS });
		if (response.ok) {
			return await response.json();
		}
	} catch (e) {
		// ignore
	}
	return null;
};
